var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nbl-p-5",attrs:{"id":"app"}},[(_vm.isCampaign)?_c('campaign-mode'):_c('full-mode')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }